export const BADGE_TYPES = {
    GREEN: "green",
    SUCCESS: "success",
    WAIT: "wait",
    INFO: "info",
    EXT: "ext",
    DOC: "doc",
    AFTERHR: "afterHr",
    WARNING: "warning",
    ERROR: "error",
};

export const BUTTON_TYPES = {
  ROUNDED: "Rounded",
  WHITE: "white-button",
  SMALLER : "smaller",
  WHITE_OUTLINE: "White Outline",
  ORANGE: "Orange",
};

export const BUTTON_VARIANTS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  DARK : "dark",
  LIGHT : "light",
  ORANGE : 'orange',
  IMAGE : 'image',
  BASIC : 'basic'
};
